module.exports = __webpack_public_path__ + "static/2021-03-10-12-54-25-778-fs8-fs8-3b5fd3246a23834dd53dda4613220388.png";